import React from 'react';
import { useSelector } from 'react-redux';
import EaHeader from '@components/ea/EaHeader';
import EaBottom from '@components/ea/EaBottom';
import NotificationInfo from '@components/ea/NotificationInfo';
import { DOC_TYPE } from '@common/constants';

const NotificationDuty = props => {
  const {
    onClickPrev,
    onClickNext,
    productInfo,
    isPracticeMode = false,
    docType = DOC_TYPE.APPL,
  } = props;
  const { customer, bundleCodeInfo } = useSelector(state => state.eaReducer);

  const notificationType = $utils.getNotificationType(bundleCodeInfo); // 알릴의무 타입
  const { isEasyProduct, isMedicalProduct, isDementiaProduct } =
    $utils.getNotificationChecks(notificationType);
  const isBeforeRevision =
    productInfo.calculateDate < '20250101' ? true : false; // 산출일 25/1/1 이전 -> 계약전알릴의무 표준약관 변경으로 이전양식 호출
  return (
    <React.Fragment>
      <EaHeader
        title={`${
          docType === DOC_TYPE.PRE_UW ? '1' : '2'
        }. 계약 정보 확인 및 작성 - 계약 전 알릴 의무`}
        isFirstPage={false}
        onClickPrev={onClickPrev}
        onClickNext={onClickNext}
        isPracticeMode={isPracticeMode}
      />
      <div className={`con-wrap bg-gray`}>
        <div className="app-wrap">
          <NotificationInfo
            name={customer.owner.name}
            isEasyProduct={isEasyProduct}
            isMedicalProduct={isMedicalProduct}
            isDementiaProduct={isDementiaProduct}
            isBeforeRevision={isBeforeRevision}
          />
        </div>
      </div>
      <EaBottom label="확인" onClick={onClickNext} />
    </React.Fragment>
  );
};

export default NotificationDuty;
